__webpack_require__.p = "https://static.magicsquare.io/launchpad/_next/";